import { render, staticRenderFns } from "./FansControlSection.vue?vue&type=template&id=77b3db7a&scoped=true&"
import script from "./FansControlSection.vue?vue&type=script&lang=js&"
export * from "./FansControlSection.vue?vue&type=script&lang=js&"
import style0 from "./FansControlSection.vue?vue&type=style&index=0&id=77b3db7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3db7a",
  null
  
)

export default component.exports